import { render, staticRenderFns } from "./BbsItem.vue?vue&type=template&id=2b185131"
import script from "./BbsItem.vue?vue&type=script&lang=js"
export * from "./BbsItem.vue?vue&type=script&lang=js"
import style0 from "./BbsItem.vue?vue&type=style&index=0&id=2b185131&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports